import { callApiNew } from 'src/middleware/apiMiddleware';

// ***** Onboarding ***** //
const getBusinessOnboarding = () =>
  callApiNew<BusinessOnboardingDetails[]>({
    endpoint: '/business-onboarding',
  });

const createBusinessOnboarding = (data: BusinessOnboardingPayload) =>
  callApiNew<BusinessOnboardingDetails>({
    endpoint: '/business-onboarding',
    method: 'post',
    body: data,
  });

const updateBusinessOnboarding = (uuid: string, data: BusinessOnboardingPayload) =>
  callApiNew<BusinessOnboardingDetails>({
    endpoint: `/business-onboarding/${uuid}`,
    method: 'patch',
    body: data,
  });

// ***** Businesses ***** //
const getExistingBusinesses = (params?: PaginationParams & { search: string }) =>
  callApiNew<PaginatedResponse<EntityFields>>({
    endpoint: '/businesses',
    params: { limit: 10, offset: 0, ...params },
  });

const getMatchingBusinesses = (uuid: string) =>
  callApiNew<EntityFields[]>({
    endpoint: `/business/${uuid}/matching-businesses`,
  });

const createBusiness = (data: EntityFields) =>
  callApiNew<EntityFields>({
    endpoint: '/business',
    method: 'post',
    body: data,
  });

const claimBusiness = (onboardingUuid: string, businessUuid: string) =>
  callApiNew<EntityFields>({
    endpoint: `/onboarding/${onboardingUuid}/business/${businessUuid}/claim`,
    method: 'post',
  });

const addBusinessLogo = (data: FormData, uuid: string) =>
  callApiNew({
    endpoint: `/business/${uuid}/logo`,
    method: 'patch',
    body: data,
  });

const getAllCommunities = (params?: PaginationParams & { search: string; businessUuid: string }) =>
  callApiNew<PaginatedResponse<EntityFields>>({
    endpoint: '/community',
    params: { limit: 10, offset: 0, ...params, business_uuid: params.businessUuid },
  });

const joinCommunity = (communityId: string, businessId: string) =>
  callApiNew<PaginatedResponse<Business>>({
    endpoint: `/community/${communityId}/business/${businessId}/join`,
    method: 'post',
  });

const addToWaitlist = (businessId: string, data: { communityName: string }) =>
  callApiNew<PaginatedResponse<EntityFields>>({
    endpoint: `/business/${businessId}/waitlist`,
    method: 'post',
    body: data,
  });

const getStatesGeoData = () =>
  callApiNew<string[]>({
    endpoint: '/geo-data',
  });

const getCitiesGeoData = (state: string[]) =>
  callApiNew<string[]>({
    endpoint: '/geo-data',
    params: { state: state ? state[0] : 'CA' },
  });

const getOnboardingApporval = (businessUuid: string) =>
  callApiNew<string[]>({
    endpoint: `/business/${businessUuid}/approval-status`,
  });

const apiUtil = {
  getBusinessOnboarding,
  createBusinessOnboarding,
  updateBusinessOnboarding,

  getExistingBusinesses,
  getMatchingBusinesses,
  createBusiness,
  addBusinessLogo,
  claimBusiness,

  getAllCommunities,
  joinCommunity,
  addToWaitlist,
  getOnboardingApporval,

  getStatesGeoData,
  getCitiesGeoData,
};

export default apiUtil;
